import { ButtonPrimary } from "components/Atoms/Button";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { DetailSidePanel } from "../DetailSidePanel";
import { BankAccountSidePanelDetails } from "./BankAccountSidePanelDetails";
import { RightClickMenu } from "components/RightClickMenu/RightClickMenuContext";
import { rightMenuForSidePanel } from "components/RightClickMenu/rightClickMenuUtils";

interface BankAccountSidePanelProps {
  bankAccountId: number
  trigger: JSX.Element
  fallbackIfNoPermission?: JSX.Element
}

export const BankAccountSidePanel = (props: BankAccountSidePanelProps) => {
  if (!site.permissions.canConfigureSystemSettings) {
    return props.fallbackIfNoPermission || props.trigger;
  }

  return <DetailSidePanel
    detailUrl={routes.bankAccount_Detail(props.bankAccountId).absolute}
    apiCall={() => window.CoreApi.BankAccount.GetBankAccount(props.bankAccountId)}
    apiKey="bankAccount"
    entityId={props.bankAccountId}
    title={RESX.BankAccount.resxBankAccount}
    footerContent={<>
      {site.permissions.canConfigureSystemSettings && <ButtonPrimary href={routes.bankAccount_Detail(props.bankAccountId).absolute} label={RESX.Buttons.DetailView} />}
    </>}
    trigger={<RightClickMenu menuItems={rightMenuForSidePanel(routes.bankAccount_Detail(props.bankAccountId).absolute)}>{props.trigger}</RightClickMenu>}
  >
    {(data) => <BankAccountSidePanelDetails
      bankAccount={data}
    />}
  </DetailSidePanel>;
}